var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"transparent",attrs:{"flat":""}},[_c('v-card-text',[(_vm.fields)?_c('editable-field',{attrs:{"field-id":"company_info"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }